






































































































































































import {API} from '@/services/api/api';
import validator from '@/utils/validator';
import {Vue, Component, Watch, Prop} from 'vue-property-decorator';
import {mapActions, mapGetters} from 'vuex';
import Drift from 'drift-zoom';
import {getImage, Utils} from '@/utils/Utils';
import canvasMerge from '@/utils/CanvasMerge';
import InnerImageZoom from 'vue-inner-image-zoom';
import 'vue-inner-image-zoom/lib/vue-inner-image-zoom.css';

@Component({
  components: {
    InnerImageZoom,
  },
  methods: {
    ...mapActions(['setInspectionData', 'setupAppData', 'showSuccessToast', 'showErrorToast']),
  },

  computed: {
    ...mapGetters(['getInspectionData', 'shipList']),
  },
})
export default class InspectionFirstStep extends Vue {
  @Prop() isReadOnly!: boolean;
  @Prop() canMappedData!: boolean;
  @Prop({default: true}) showDuplicateFields!: boolean;

  setInspectionData: any;
  getInspectionData: any;
  setupAppData: any;

  isSomeDataMissing = true;
  shipList: any;
  showSuccessToast: any;
  showErrorToast: any;
  drift: any;
  isScreenLoading = true;
  miscStructureStatus = false;
  selectedShipId = null;
  shipValidationMsg = '';
  deckValidationMsg = '';
  commonValidationMsg = 'This field is required';
  zoneValidationMsg = '';
  structureValidationMsg = '';
  frameValidationMsg = '';
  zoneName = '';
  frameNumber: number = null;
  inspectionCode: number = null;
  deckDots = [];
  selectedDeckId: string = null;
  selectedZoneId: string = null;
  positionX: number = null;
  positionY: number = null;
  howercontectText = '';
  deckImageURL = '';
  showZoneData = '';
  frameListData = [];
  frameStart: number = null;
  frameEnd: number = null;

  newDeckImageWithPoints: string | null = null;
  deckImageLoader = false;

  deckList = [];
  inspectionList = [];
  createdDeckImageUrl = '';

  selectedZoneName = null;
  zoneList = [];
  selectedStrucId = null;
  structureList = [
    {structureId: 1, name: 'Fire Doors'},
    {structureId: 2, name: 'Compartment Doors'},
    {structureId: 3, name: 'Others'},
  ];

  selectedFrameName = '';
  frameList = [
    {frameId: 1, name: 'Port'},
    {frameId: 2, name: 'Center'},
    {frameId: 3, name: 'Starboard'},
  ];
  firstStepData: any;
  centerFrom = 0;
  centerUpto = 0;
  deckStartPoint = 0;
  deckEndpoint = 0;
  mounted() {
    if (this.getInspectionData.firstStep !== undefined && this.canMappedData) {
      this.mappedDataIntoFields();
    }
    this.loadFrames();
  }

  firstStepValidator() {
    if (this.validateAll()) {
      this.setInspectionData({
        key: 'firstStep',
        payload: {
          zoneName: this.zoneName,
          frameSide: this.selectedFrameName || 'Port',
          shipId: this.selectedShipId,
          isMisc: this.miscStructureStatus,
          deckId: this.selectedDeckId,
          structure: this.selectedStrucId,
          zoneId: this.selectedZoneId,
          zoneMasterId: this.selectedZoneId,
          inspectionCode: this.inspectionCode,
          deckImage: this.deckImageURL,
          location_X: this.positionX,
          location_Y: this.positionY,
          frameNumber: this.frameNumber,
          frameStart: this.frameStart,
          frameEnd: this.frameEnd,
        },
      });

      //
      //   'in firstStepValidator in 1st step',
      //   this.frameStart,
      //   this.frameEnd
      // );

      this.$emit('onNextClick', 1);
    }
  }

  async getDecksByShipId() {
    //  this.selectedDeckId=null;
    //       this.deckImageURL=''
    try {
      this.isScreenLoading = true;
      const params = {
        alldecks: 1,
        withoutzones: 0,
        withoutcenter: 0,
      };
      const response = await API.fetchEmptyDecksByShipId(params, this.selectedShipId);

      if (response.data) {
        const data = response.data;

        if (data.drawings.length > 0) {
          this.deckList = data.drawings;

          if (this.selectedDeckId !== null) {
            this.showDeckImage();
          }
        } else this.showErrorToast({msg: 'No deck found for this ship'});
      } else {
        this.showErrorToast({msg: response.error});
      }
    } catch (error) {
      this.showErrorToast({msg: error});
    } finally {
      this.isScreenLoading = false;
    }
  }

  async showDeckImage() {
    try {
      this.deckImageLoader = true;

      const index = this.deckList.findIndex((data) => data.drawingId === this.selectedDeckId);

      if (index !== undefined || index !== -1) {
        const response = await API.fetchCenterPointList();

        if (response.data) {
          const data = response.data;
          const centerPoints = data.find((centerPoints) => centerPoints.deckId == this.deckList[index].drawingId);

          if (centerPoints) {
            this.centerFrom = centerPoints.centerFrom;
            this.centerUpto = centerPoints.centerUpto;
          }
        }
      }

      if (index !== undefined || index !== -1) {
        this.deckImageURL = await getImage(this.deckList[index].imagePath);
        if (this.deckList[index].scanResult && this.deckList[index].scanResult != null) {
          const scanResult = JSON.parse(this.deckList[index].scanResult);
          if (scanResult && scanResult.Deck) {
            this.deckStartPoint = scanResult.Deck.StartPoint.X;
            this.deckEndpoint = scanResult.Deck.EndPoint.X;
          }
        }
      }
    } catch (error) {
      this.showErrorToast({msg: 'Network error'});
    }
  }

  getDeckData(e) {
    var imageRef = this.$refs.deckImageRef as HTMLImageElement;
    const data = $(imageRef);
    // //  var divTop = document.getElementById('ImageDetail_Thumbnail').offsetLeft;
    var tempScrollTop = $(window).scrollTop();
    var offset_t = data.offset().top - $(window).scrollTop();
    var offset_l = data.offset().left - $(window).scrollLeft();
    var posx = e.clientX - offset_l;
    var posy = e.clientY - offset_t;
    this.positionX = (imageRef.naturalWidth / imageRef.width) * posx;
    this.positionY = (imageRef.naturalHeight / imageRef.height) * posy;
    if (
      (this.deckEndpoint && this.positionX > this.deckEndpoint) ||
      (this.deckStartPoint && this.positionX < this.deckStartPoint)
    ) {
      this.showErrorToast({msg: 'Please select a point on deck'});
      return;
    }
    //

    if (this.createdDeckImageUrl !== '' || this.createdDeckImageUrl !== null) {
      this.deckDots.map((dots) => {
        if (Utils.mouseDistance(dots.x, dots.y, this.positionX, this.positionY) < 0.003 * imageRef.naturalWidth) {
          this.$router.push(`/view-inspection/` + dots.inspectionID);
        }
      });
    }

    if (this.positionX) {
      const zone = this.zoneList.find((me) => {
        //
        return me.zoneStartPoint <= this.positionX && this.positionX <= me.zoneEndPoint;
      });

      //

      if (zone !== undefined) {
        //

        if (this.frameListData.length > 0) {
          //

          const frame = this.frameListData.find((me) => {
            return me.zoneDeckId === zone.zoneDeckId;
          });
          if (frame === undefined) {
            this.showErrorToast({
              msg: 'Frame not available in this zone please create frame first',
            });
          } else {
            let frameCount = frame.frameofZones[0].frameUpto - frame.frameofZones[0].frameFrom;
            let pixelsCountInZone = zone.zoneEndPoint - zone.zoneStartPoint;
            let pixelsInEachframes = pixelsCountInZone / frameCount;
            let a = this.positionX - zone.zoneStartPoint;
            let cc = a / pixelsInEachframes;
            let dd = Math.round(frame.frameofZones[0].frameFrom + cc);
            this.zoneName = zone.zoneName;
            this.selectedZoneId = zone.zoneDeckId;
            this.frameNumber = dd;

            this.frameStart = frame.frameofZones[0].frameFrom;
            this.frameEnd = frame.frameofZones[0].frameUpto;

            //
            this.mergeImage('points');
            this.setFrameSide(zone.zoneName, this.frameNumber, this.positionX);
            this.$forceUpdate();
          }
        }
      } else {
        this.howercontectText = '';
        this.showZoneData = '';
        this.showErrorToast({msg: 'Zone not available in this point.'});
      }
    }

    //

    // try {
    //   this.isScreenLoading = true;
    //   const response = await API.fetchInspectionPointOnDeck(
    //     this.selectedShipId,
    //     this.selectedDeckId,
    //     this.positionX
    //   );
    //   if (response.data) {
    //     //

    //     const data = response.data;
    //     this.selectedZoneId = data.zone.zoneDeckId;

    //     this.zoneName = data.zone.zoneName;

    //     if (!this.selectedZoneId) this.getInspectionCode();
    //   } else {
    //     this.showErrorToast({msg: response.error});
    //     this.zoneList = [];
    //     this.selectedZoneName = null;
    //   }
    // } catch (error) {
    //   this.showErrorToast({msg: error});
    // } finally {
    //   this.isScreenLoading = false;
    // }
  }

  setFrameSide(zoneName, selectedFrameNumber, posx) {
    if (this.centerFrom == 0 && this.centerUpto == 0) {
      this.showErrorToast({msg: 'Center Points is not defined for deck.'});
    } else {
      if (this.positionY < this.centerFrom) {
        this.selectedFrameName = 'Port';
      } else if (this.positionY > this.centerFrom && this.positionY < this.centerUpto) {
        this.selectedFrameName = 'Center';
      } else {
        this.selectedFrameName = 'Starboard';
      }
      this.showZoneData = `Selected zone is ${zoneName}  frame is ${selectedFrameNumber} and selected frame side is ${this.selectedFrameName}`;
      if (this.deckEndpoint && this.deckStartPoint) {
        if (this.deckStartPoint > posx || posx > this.deckEndpoint) {
          this.showZoneData =
            this.showZoneData + ' <span style="color:#dc3545"> (Your selected Frame is outside of the Deck)</span>';
        }
      }
    }
  }
  // loadClickedPointOnDeck() {
  //   this.positionX;
  //   this.positionY;
  //   this.deckImageURL;
  // }

  async getZonessByDeckId() {
    try {
      this.isScreenLoading = true;

      const response = await API.fetchZonesByDeckId(this.selectedDeckId);

      if (response.data) {
        const data = response.data;

        this.zoneList = data;
      } else {
        this.showErrorToast({msg: response.error});
        this.zoneList = [];
        this.selectedZoneName = null;
      }
    } catch (error) {
      this.showErrorToast({msg: error});
      this.createdDeckImageUrl = '';
    } finally {
      this.isScreenLoading = false;
    }
  }

  async getInspectionCode() {
    try {
      // this.isScreenLoading = true;
      const response = await API.fetchInspectionId(this.selectedZoneId);
      if (response.data) {
        const data = response.data;

        this.inspectionCode = data.inspectioncode;
      } else {
        this.showErrorToast({msg: response.error});
        this.zoneList = [];
        this.selectedZoneName = null;
      }
    } catch (error) {
      this.showErrorToast({msg: error});
    } finally {
      this.isScreenLoading = false;
    }
  }

  //initialize zoomed container on hover imag
  initDriftZoom() {
    document.querySelectorAll('.drift-bounding-box').forEach((element) => {
      element.remove();
    });

    this.drift = new Drift(this.$refs.image, {
      paneContainer: document.getElementById('ppppp'),
      // inlinePane: 900,
      inlineOffsetY: -85,
      containInline: true,
      handleTouch: false,
      inlinePane: false,
      zoomFactor: 5,
      hoverBoundingBox: true,
    });
  }

  //disable zoomed container on hover image
  disableDriftZoom() {
    if (this.drift) {
      this.drift.destroy();
    }
  }

  mappedDataIntoFields() {
    var firstStepData = this.getInspectionData.firstStep;
    var secondStepData = this.getInspectionData.secondStep;
    this.selectedShipId = firstStepData.shipId;
    this.selectedDeckId = firstStepData.deckId;
    this.miscStructureStatus = firstStepData.isMisc;
    this.selectedStrucId = firstStepData.structure;
    this.selectedFrameName = firstStepData.frameSide;
    this.zoneName = firstStepData.zoneName;
    this.selectedZoneId = firstStepData.zoneId;
    this.inspectionCode = firstStepData.inspectionCode;
    this.deckImageURL = firstStepData.deckImage;
    this.frameNumber = firstStepData.frameNumber;
    this.frameStart = firstStepData.frameStart;
    this.frameEnd = firstStepData.frameEnd;
    //
    //   'in mappedDataIntoFields in 1st step',
    //   firstStepData.frameStart,
    //   firstStepData.frameEnd
    // );
  }

  onChangeDeck() {
    if (validator.isNullOrEmpty(this.selectedDeckId)) {
      this.deckValidationMsg = this.commonValidationMsg;
      return false;
    } else {
      this.selectedZoneId = null;
      this.deckValidationMsg = '';
      this.deckImageURL = '';
      this.createdDeckImageUrl = '';
      this.newDeckImageWithPoints = null;
      this.showZoneData = null;
      this.howercontectText = '';
      this.centerFrom = 0;
      this.centerUpto = 0;
      this.deckStartPoint = 0;
      this.deckEndpoint = 0;
      this.showDeckImage();
      return true;
    }
  }

  validateAll() {
    return (
      this.validateShipSelect() &&
      this.validateDeckSelect() &&
      this.validateZoneSelect() &&
      this.validateStrucSelect() &&
      this.validateFrameSelect()
    );
  }

  validateShipSelect() {
    if (validator.isNullOrEmpty(this.selectedShipId)) {
      this.shipValidationMsg = this.commonValidationMsg;
      return false;
    } else {
      this.shipValidationMsg = '';

      return true;
    }
  }
  validateDeckSelect() {
    if (validator.isNullOrEmpty(this.selectedDeckId)) {
      this.deckValidationMsg = this.commonValidationMsg;
      return false;
    } else {
      this.deckValidationMsg = '';
      return true;
    }
  }

  validateZoneSelect() {
    if (validator.isNullOrEmpty(this.selectedZoneId) && this.miscStructureStatus) {
      this.zoneValidationMsg = this.commonValidationMsg;
      return false;
    } else if (validator.isNullOrEmpty(this.selectedZoneId) && !this.miscStructureStatus) {
      this.showErrorToast({
        msg: 'Either click on image or select zone manually.',
      });
      return false;
    } else {
      this.zoneValidationMsg = '';
      if (this.frameListData.length > 0) {
        //

        const frame = this.frameListData.find((me) => {
          return me.zoneDeckId === this.selectedZoneId;
        });
        if (frame === undefined) {
          this.showErrorToast({
            msg: 'Frame not available in this zone please create frame first',
          });
          return false;
        } else {
          this.frameStart = frame.frameofZones[0].frameFrom;
          this.frameEnd = frame.frameofZones[0].frameUpto;
          return true;
        }
      }
    }
  }

  validateStrucSelect() {
    if (validator.isNullOrEmpty(this.selectedStrucId) && this.miscStructureStatus) {
      this.structureValidationMsg = this.commonValidationMsg;
      return false;
    } else {
      this.structureValidationMsg = '';
      return true;
    }
  }

  validateFrameSelect() {
    if (validator.isNullOrEmpty(this.selectedFrameName)) {
      this.frameValidationMsg = this.commonValidationMsg;

      return false;
    } else {
      this.frameValidationMsg = '';
      return true;
    }
  }

  onShipChange() {
    if (this.validateShipSelect()) {
      this.selectedDeckId = null;
      this.deckImageURL = '';
      this.createdDeckImageUrl = '';
      // this.createdDeckImageUrl='';
    }
  }

  async getInspectionByDeckId() {
    try {
      this.inspectionList = [];
      // this.isScreenLoading = true;
      const param = {
        ShipId: this.selectedShipId,
        DeckId: this.selectedDeckId,
        // ShipId: null,

        FromDate: null,
        EndDate: null,
      };
      const response = await API.getInspectionListByShip(param);
      if (response.data) {
        this.inspectionList = response.data;

        //
        this.renderDotDeck();
      } else if (response.errors) {
        this.deckImageLoader = false;
        if (response.errors.ShipId) {
          this.showErrorToast({msg: response.errors.ShipId[0]});
        } else if (response.errors.InspectionId) {
          this.showErrorToast({msg: response.errors.InspectionId[0]});
        } else if (response.errors.FromDate) {
          this.showErrorToast({msg: response.errors.FromDate[0]});
        } else if (response.errors.ToDate) {
          this.showErrorToast({msg: response.errors.ToDate[0]});
        }
      } else {
        this.showErrorToast({msg: 'Network error'});
      }
      //
    } catch (error) {
      this.showErrorToast({msg: 'Network error'});
      this.deckImageLoader = false;
    } finally {
      this.isScreenLoading = false;
    }
  }

  onDeckLoad() {
    let _this = this;
    // this.renderDot();
    window.onmousemove = function (e) {
      //

      const main = e.target as HTMLImageElement;
      //

      if (main.classList.contains('deckImg')) {
        //	Content of dot which is hovered
        const $target = main.nextElementSibling as HTMLElement;
        //

        //	Only work with hovered target
        //	Add visible class hovered elem to distinguish
        if (!$target.classList.contains('visible')) {
          $target.classList.add('visible');
        } else {
          //	Get viewport offset of tooltip element
          let offset = $target.parentElement.getBoundingClientRect();
          //	Tooltip distance from mouse(px)
          let tipDist = 15;
          //	Calc and set new tooltip location
          $target.style.top = e.clientY - offset.top + tipDist + 'px';
          $target.style.left = e.clientX - offset.left + tipDist + 'px';

          offset = main.getBoundingClientRect();
          let x = e.clientX - offset.left;
          let y = e.clientY - offset.top;
          let cw = main.clientWidth;
          let ch = main.clientHeight;
          let iw = main.naturalWidth;
          let ih = main.naturalHeight;
          let posx = (x / cw) * iw;
          let posy = (y / ch) * ih;

          let detactMouse = false;
          // _this.deckDots.map((dots) => {
          //   if (
          //     Utils.mouseDistance(dots.x, dots.y, posx, posy) <
          //     0.005 * main.clientWidth
          //   ) {
          //     //
          //     _this.howercontectText =
          //       'Click here to view inspection : ' +
          //       dots.inspectionCode +
          //       ' (ID: ' +
          //       dots.inspectionID +
          //       ')';
          //     main.style.cursor = 'pointer';
          //     detactMouse = true;
          //   }
          // });

          if (!detactMouse) {
            const zone = _this.zoneList.find((me) => {
              //
              return me.zoneStartPoint <= posx && posx <= me.zoneEndPoint;
            });
            //

            //

            if (zone !== undefined) {
              //

              if (_this.frameListData.length > 0) {
                // console.table([_this.frameListData]);

                const frame = _this.frameListData.find((me) => {
                  return me.zoneDeckId === zone.zoneDeckId;
                });
                //
                if (frame === undefined) {
                  // _this.showErrorToast({
                  //   msg: 'Frame not available please create frame first',
                  // });
                  _this.howercontectText = '';
                } else {
                  let frameCount = frame.frameofZones[0].frameUpto - frame.frameofZones[0].frameFrom;
                  let pixelsCountInZone = zone.zoneEndPoint - zone.zoneStartPoint;

                  let pixelsInEachframes = pixelsCountInZone / frameCount;
                  let a = posx - zone.zoneStartPoint;

                  let cc = a / pixelsInEachframes;

                  let dd = Math.round(frame.frameofZones[0].frameFrom + cc);

                  //
                  //
                  //   posx,
                  //   zone.zoneStartPoint,
                  //   zone.zoneEndPoint,
                  //   posx < zone.zoneStartPoint || posx > zone.zoneEndPoint
                  // );

                  _this.howercontectText =
                    '<span style="padding: 2px 5px; display: inline-block;">This is zone: ' +
                    zone.zoneName +
                    ' ' +
                    'and frame' +
                    ' ' +
                    dd +
                    '</span>';
                  main.style.cursor = 'unset';

                  if (_this.deckEndpoint && _this.deckStartPoint) {
                    if (_this.deckStartPoint > posx || posx > _this.deckEndpoint) {
                      _this.howercontectText =
                        _this.howercontectText +
                        ' <span style="padding: 2px 5px;color:#fff; background-color: #dc3545; display: inline-block">  (This Frame is outside of the Deck)</span>';
                    }
                  }

                  //

                  _this.$forceUpdate();

                  //         restPixels
                  // let thisframePosition =  frame.frameofZones[0].frameUpto - ;
                  // let framePosition =
                  //   points.zoneStartPoint + thisframePosition * pixelsInEachframes;
                }
              }
            } else {
              _this.howercontectText = '';
            }

            // const decks = ship.dra0wing;

            // const deck = decks.find((d) => d.topY <= posy && posy <= d.bottomY);
            // if (deck) {
            //   _this.howercontectText =
            //     'this is zone: ' + zone.zoneName + ' ' + 'and frame'+' ';
            //   main.style.cursor = 'unset';
            // } else {
            //   _this.howercontectText = '';
            //   main.style.cursor = 'unset';
            // }
          }
        }
      } else if (main.classList.contains('deckImg')) {
        //	Content of dot which is hovered
        let imageRef = _this.$refs.deckImageRef as HTMLImageElement;
        let offset = imageRef.getBoundingClientRect();
        let x = e.clientX - offset.left;
        let y = e.clientY - offset.top;
        let cw = main.clientWidth;
        let ch = main.clientHeight;
        let iw = main.naturalWidth;
        let ih = main.naturalHeight;
        let posx = (x / cw) * iw;
        let posy = (y / ch) * ih;

        let detactMouse = false;
        _this.deckDots.map((dots) => {
          if (Utils.mouseDistance(dots.x, dots.y, posx, posy) < 0.005 * main.clientWidth) {
            //
            _this.howercontectText =
              'Click here to view inspection : ' + dots.inspectionCode + ' (ID: ' + dots.inspectionID + ')';
            main.style.cursor = 'pointer';
            detactMouse = true;
          }
        });
        if (!detactMouse) {
          main.style.cursor = 'unset';
          _this.howercontectText = '';
        }
      } else {
        //	Remove visible class
        var content = document.getElementsByClassName('hovercontent');
        for (var i = 0; i < content.length; i++) {
          content[i].classList.remove('visible');
        }
      }
    };
  }

  async loadFrames() {
    // this.isScreenLoading = true;
    try {
      const response = await API.fetchFrameList();

      if (response.data) {
        let data = response.data;
        this.frameListData = data;

        // this.modifyArray(frame);
      } else {
        this.showErrorToast({msg: response.message});
        this.isScreenLoading = false;
      }
    } catch (error) {
      this.showErrorToast({msg: 'Network error'});
      this.isScreenLoading = false;
    }
  }

  renderDotDeck() {
    this.deckDots = [];
    // createdShipImage
    if (this.deckImageURL && this.inspectionList.length > 0) {
      let imageRef = this.$refs.deckImageRef as HTMLImageElement;
      this.inspectionList.map((inspection) => {
        const points = inspection.additionalInfo;
        let x,
          y = null;

        if (inspection.isMisc) {
          y = (points.centerFrom + points.centerUpto) / 2;

          let totalFrame = points.frameUpto - points.frameFrom;
          let pixelsCountInZone = points.zoneEndPoint - points.zoneStartPoint;
          let pixelsInEachframes = pixelsCountInZone / totalFrame;
          let thisframePosition = points.frameUpto - inspection.frameNumber;
          let framePosition = points.zoneStartPoint + thisframePosition * pixelsInEachframes;
          x = framePosition;
        } else {
          y = points.location_Y;
          x = points.location_X;
        }
        this.deckDots.push({
          x: x,
          y: y,
          radius: 0.003 * imageRef.naturalWidth,
          color: Utils.getBackgroundColor(inspection.severity),
          inspectionID: inspection.inspectionID,
          inspectionCode: inspection.inspectionCode,
        });
      });
      this.mergeImage('inspection');
    }
  }
  mergeImage(mergeType) {
    let img = this.deckImageURL;
    let dots = this.deckDots;

    if (mergeType === 'inspection') {
      canvasMerge(img, dots, {
        crossOrigin: 'anonymous',
        drawType: 'circle',
      }).then((b64) => {
        //
        this.createdDeckImageUrl = b64;
      });
    } else {
      dots = [];
      let imageRef = this.$refs.deckImageRef as HTMLImageElement;

      dots.push({
        x: this.positionX,
        y: this.positionY,
        radius: 0.003 * imageRef.naturalWidth,
        color: '#FF0000',
      });

      canvasMerge(img, dots, {
        crossOrigin: 'anonymous',
        drawType: 'emptyCircle',
      }).then((b64) => {
        //
        this.newDeckImageWithPoints = b64;
        this.deckImageLoader = false;
      });
    }
  }

  //Watchers
  @Watch('shipList', {immediate: true})
  isShipLoaded(shipList) {
    if (shipList.length > 0) this.isScreenLoading = false;
    // this.$emit('closeLoader')
  }

  @Watch('selectedShipId', {immediate: true})
  fetchDecks() {
    if (this.selectedShipId !== null) {
      this.getDecksByShipId();
    }
  }

  @Watch('selectedDeckId', {immediate: true})
  fetchZones() {
    if (this.selectedDeckId !== null) {
      this.getZonessByDeckId();
    }
  }
  @Watch('selectedZoneId', {immediate: true})
  fetchInspectionCode() {
    if (this.selectedZoneId !== null) {
      const zone = this.zoneList.find((zone) => {
        return zone.zoneDeckId === this.selectedZoneId;
      });
      if (zone === undefined) return;
      else this.zoneName = zone.zoneName;

      this.getInspectionCode();
    }
  }
}
